/*
** @desc:    '广告插件统计'
** @author:  'yanmao@sohu-inc.com'
** @date:    2017-08-24
*/
import Exposure from '../_utils/exposure';
import SohuStat from './sohu-stat';
import EventHelper from '../_utils/eventHelper';

var AdPluginStat = (function() {
    var exposure = new Exposure();
    var adList;

    function init(adList) {
        adList = adList || document.querySelectorAll('iframe[data-appid]');
        //监听message事件
        EventHelper.addHandler(window, 'message', function(e) {
            // console.log('触发message，数据是：', e.data);
            // 传过来的数据是JSON字符串时才处理，保证格式正确
            if (typeof e.data == 'string') {

                try {
                    var data = JSON.parse(data);
                    if(data && data.appId && data.actionId ){
                        sendAppAction(data.appId, data.actionId);
                    }else{
                        console.log("message格式不正确");
                    }
                } catch(err) {
                        console.log("message格式不正确");
                }
            }
        })
        addExpose(adList);
        exposure.allExposureCheck();
        exposure.addListener();
    }

    function addExpose(adList) {
        var length = adList.length;
        for(var i=0; i<length; i++) {
            (function(i) {
                var dom = adList[i];
                // 获取当前曝光元素的appId
                var appId = dom.getAttribute('data-appid');
                var eid = dom.getAttribute('data-eid');
                // appId和eid存在时才添加曝光
                if(appId && eid) {
                    exposure.add({
                        dom: dom,
                        callback: function() {
                            sendAppAction(appId, eid);
                        }
                    });
                }
            })(i);
        }
    }

    function sendAppAction(appId, actionId) {
        var newsId;
        var mediaId;
        // 发送之前获取当前的mediaId和newsId
        var twoIds = getMedia2NewsId(newsId, mediaId);
        if(appId && actionId) {
            SohuStat.sendStatistics('appAction', {
                appId,
                actionId,
                mediaId: twoIds.mediaId,
                newsId: twoIds.newsId,
                lobId: '001' // 固定值
            });
        }
    }

    function getMedia2NewsId() {
        var pagePath = window.location.pathname;
        var reg = /\a\/(\d*)_(\d*)/;
        var twoIds = pagePath.match(reg);
        var newsId = twoIds && twoIds[1] ;
        var mediaId = twoIds && twoIds[2] || 0;
        return {
            newsId,
            mediaId
        }
    }

    return {
        init,
        addExpose
    }
})();

export default AdPluginStat;